import { ConnectAuthComponent } from "./connect-auth/connect-auth.component";
import { VideoPlayerComponent } from "./video-player/video-player.component";
import { DownloadTileComponent } from "./download-tile/download-tile.component";
import { VideoRailComponent } from "./video-rail/video-rail.component";
import { ProductTileComponent } from "./product-tile/product-tile.component";
import { FilterableVideoGroupComponent } from "./filterable-video-group/filterable-video-group.component";
import { CommunityFeedComponent } from "./community-feed/community-feed.component";
import { ExchangeListItemComponent } from "./exchange-list-item/exchange-list-item.component";
import { StarsComponent } from "./stars/stars.component";
import { SwitchComponent } from "./switch/switch.component";
import { SvgComponent } from "./svg/svg.component";
import { AutocompleteDropdownComponent } from "./autocomplete-dropdown/autocomplete-dropdown.component";
import { NewProductAddedComponent } from "./new-product-added/new-product-added.component";
import { InstallerButtonsComponent } from "./installer-buttons/installer-buttons.component";
import { BundledDownloadsComponent } from "./bundled-downloads/bundled-downloads.component";
import { ProductDownloadsComponent } from "./product-downloads/product-downloads.component";
import { ExchangeListComponent } from "./exchange-list/exchange-list.component";
import { ExchangeDetailComponent } from "./exchange-detail/exchange-detail.component";
import { BrowseExchangeComponent } from "./browse-exchange/browse-exchange.component";
import { CreatorComponent } from "./creator/creator.component";
import { ProfileComponent } from "./profile/profile.component";
import { LoginComponent } from "./login/login.component";
import { KnowledgebaseComponent } from "./knowledgebase/knowledgebase.component";
import { TicketDetailComponent } from "./ticket-detail/ticket-detail.component";
import { FeaturedCreatorsComponent } from "./featured-creators/featured-creators.component";
import { ProductFilterComponent } from "./product-filter/product-filter.component";
import { CloudNavComponent } from "./cloud-nav/cloud-nav.component";
import { AdminNavComponent } from "./admin-nav/admin-nav.component";
import { ProductDetailComponent } from "./product-detail/product-detail.component";
import { ProductsListComponent } from "./products-list/products-list.component";
import { AccountComponent } from "./account/account.component";
import { SupportComponent } from "./support/support.component";
import { GeneralComponent } from "./account/sections/general/general.component";
import { SkillsComponent } from "./account/sections/skills/skills.component";
import { AddressesComponent } from "./account/sections/addresses/addresses.component";
import { GiftCardsComponent } from "./account/sections/gift-cards/gift-cards.component";
import { AccountOrdersComponent } from "./account/sections/orders/orders.component";
import { ShowcasesComponent } from "./account/sections/showcases/showcases.component";
import { AccountCollaborationComponent } from "./account/sections/collaboration/collaboration.component";
import { ConnectionsComponent } from "./account/sections/connections/connections.component";
import { DiscordMigrationWelcomeComponent } from "./modals/discord-migration-welcome/discord-migration-welcome.component";
import { DiscordClaimComponent } from "./modals/discord-claim/discord-claim.component";
import { DiscordFreeFspOfferComponent } from "./discord-free-fsp-offer/discord-free-fsp-offer.component";
import { AccountFileManagementComponent } from "./account/sections/file-management/file-management.component";
import { NotificationsComponent } from "./account/sections/notifications/notifications.component";
import { CloudNavOverlayComponent } from "./cloud-nav-overlay/cloud-nav-overlay.component";
import { WorkspaceDetailComponent } from "./workspace-detail/workspace-detail.component";
import { FileDetailComponent } from "./file-detail/file-detail.component";
import { CollaborationInviteNoticeComponent } from "./collaboration-invite-notice/collaboration-invite-notice.component";
import { FuiEventsComponent } from "./fui-events/fui-events.component";
import { FuiEventDetailComponent } from "./fui-event-detail/fui-event-detail.component";
import { FuiUpcomingLiveEventComponent } from "./fui-upcoming-live-event/fui-upcoming-live-event.component";
import { FuiEmbedLivestreamComponent } from "./fui-embed-livestream/fui-embed-livestream.component";
import { FuiLivestreamCountdownComponent } from "./fui-livestream-countdown/fui-livestream-countdown.component";
import { FuiEmbedSignupComponent } from "./fui-embed-signup/fui-embed-signup.component";
import { FuiQuillEditorComponent } from "./fui-quill-editor/fui-quill-editor.component";
import { OrdersComponent } from "./orders/orders.component";
import { SegmentedBarComponent } from "./segmented-bar/segmented-bar.component";
import { ImageViewerComponent } from "./image-viewer/image-viewer.component";
import { MessageInputComponent } from "./message-input/message-input.component";
import { MentionPickerComponent } from "./mention-picker/mention-picker.component";
import { ChatComponent } from "./chat/chat.component";
import { VideoNotesComponent } from "./video-notes/video-notes.component";
import { NotificationComponent } from "./notification/notification.component";
import { AudioPlayerComponent } from "./audio-player/audio-player.component";
import { CommentComponent } from "./comment/comment.component";
import { ReactionControlComponent } from "./reaction-control/reaction-control.component";
import { UserHoverCardComponent } from "./user-hover-card/user-hover-card.component";
import { InlineLoaderComponent } from "./inline-loader/inline-loader.component";
import { WorkspaceFilesComponent } from "./workspace-files/workspace-files.component";
import { WaveformCommentsComponent } from "./waveform-comments/waveform-comments.component";
import { WaveformContainerComponent } from "./waveform-container/waveform-container.component";
import { SatelliteComponent } from "./satellite/satellite.component";
import { SatelliteDetailComponent } from "./satellite-detail/satellite-detail.component";
import { MainProductsComponent } from "./main-products/main-products.component";
import { MainExchangeComponent } from "./main-exchange/main-exchange.component";
import { DashboardHomeComponent } from "./dashboard-home/dashboard-home.component";
import { GuestHomeComponent } from "./guest-home/guest-home.component";
import { ListItemComponent } from "./list-item/list-item.component";
import { CommunityComponent } from "./community/community.component";
import { NotificationsOverlayComponent } from "./notifications-overlay/notifications-overlay.component";
import { NotificationItemComponent } from "./notification-item/notification-item.component";
import { DemoSignupComponent } from "./demo-signup/demo-signup.component";
import { FuiLearnComponent } from "./fui-learn/fui-learn.component";
import { VideoListItemComponent } from "./video-list-item/video-list-item.component";
import { CourseDetailComponent } from "./course-detail/course-detail.component";
import { OrderDetailComponent } from "./order-detail/order-detail.component";
import { LearnListItemComponent } from "./learn-list-item/learn-list-item.component";
import { LearnContentPickerComponent } from "./learn-content-picker/learn-content-picker.component";
import { LessonDetailComponent } from "./lesson-detail/lesson-detail.component";
import { ACCOUNT_COMPONENTS } from "./account";
import { COMMUNITY_COMPONENTS } from "./community";
import { ADMIN_COMPONENTS } from "./admin";
import { ADMINPORTAL_COMPONENTS } from "./admin-portal";

import { MODALS_COMPONENTS } from "./modals";
import { VideoGridItemComponent } from "./video-grid-item/video-grid-item.component";
import { PlanStripeComponent } from "./account/sections/plan-stripe/plan-stripe.component";
import { PlanGenericComponent } from "./account/sections/plan-generic/plan-generic.component";
import { AccountPlanFspUpsellComponent } from "./account/sections/plan-fsp-upsell/plan-fsp-upsell.component";

import { NotificationPreferencesComponent } from "./notification-preferences/notification-preferences.component";

import { CommunitySearchComponent } from "./community-search/community-search.component";
import { CommunityPostDetailComponent } from "./community-post-detail/community-post-detail.component";
import { ProductPurchaseUpgradeComponent } from "./product-purchase-upgrade/product-purchase-upgrade.component";
import { StripePaymentComponent } from "./stripe-payment/stripe-payment.component";
import { CheckoutProductDetailsComponent } from "./checkout-product-details/checkout-product-details.component";
import { MissedPaymentNotice } from "./missed-payment-notice/missed-payment-notice.component";
import { PaginatorComponent } from "./paginator/paginator.component";
import { OnboardingOptionsComponent } from "./onboarding-options/onboarding-options.component";
import { SkeletonLoaderComponent } from "./skeleton-loader/skeleton-loader.component";
import { UserOrderListComponent } from "./user-order-list/user-order-list.component";
import { FENDERUI_COMPONENTS } from "./fender-ui";
import { SubscriptionTimeMeterComponent } from "./subscription-time-meter/subscription-time-meter.component";
import { S1StatusHeaderComponent } from "./s1-status-header/s1-status-header.component";
import { PlayPlanComponent } from "./account/sections/play-plan/play-plan.component";
import { FuiWorkspacesListComponent } from "./fui-workspaces-list/fui-workspaces-list.component";

export const UI_COMPONENTS = [
  CommunityFeedComponent,
  FuiLearnComponent,
  CommentComponent,
  ReactionControlComponent,
  UserHoverCardComponent,
  S1StatusHeaderComponent,
  OrderDetailComponent,
  VideoRailComponent,
  FilterableVideoGroupComponent,
  VideoPlayerComponent,
  LearnListItemComponent,
  LearnContentPickerComponent,
  DownloadTileComponent,
  ProductTileComponent,
  ExchangeListItemComponent,
  StarsComponent,
  SwitchComponent,
  SvgComponent,
  AutocompleteDropdownComponent,
  NewProductAddedComponent,
  InstallerButtonsComponent,
  SkeletonLoaderComponent,
  BundledDownloadsComponent,
  ProductDownloadsComponent,
  ExchangeListComponent,
  ExchangeDetailComponent,
  BrowseExchangeComponent,
  CreatorComponent,
  ProfileComponent,
  LoginComponent,
  KnowledgebaseComponent,
  TicketDetailComponent,
  FeaturedCreatorsComponent,
  ProductFilterComponent,
  CloudNavComponent,
  AdminNavComponent,
  ProductDetailComponent,
  ProductsListComponent,
  AccountComponent,
  SupportComponent,
  GeneralComponent,
  SkillsComponent,
  ShowcasesComponent,
  AccountCollaborationComponent,
  ConnectionsComponent,
  DiscordMigrationWelcomeComponent,
  DiscordClaimComponent,
  DiscordFreeFspOfferComponent,
  PlanStripeComponent,
  AccountPlanFspUpsellComponent,
  PlayPlanComponent,
  PlanGenericComponent,
  AccountFileManagementComponent,
  NotificationsComponent,
  CloudNavOverlayComponent,
  NotificationsOverlayComponent,
  NotificationItemComponent,
  FuiWorkspacesListComponent,
  WorkspaceDetailComponent,
  FileDetailComponent,
  CollaborationInviteNoticeComponent,
  FuiEventsComponent,
  FuiEventDetailComponent,
  FuiUpcomingLiveEventComponent,
  FuiEmbedLivestreamComponent,
  FuiLivestreamCountdownComponent,
  FuiEmbedSignupComponent,
  FuiQuillEditorComponent,
  OrdersComponent,
  SegmentedBarComponent,
  ImageViewerComponent,
  MessageInputComponent,
  MentionPickerComponent,
  ChatComponent,
  VideoNotesComponent,
  NotificationComponent,
  AudioPlayerComponent,
  InlineLoaderComponent,
  SubscriptionTimeMeterComponent,
  WorkspaceFilesComponent,
  WaveformCommentsComponent,
  WaveformContainerComponent,
  OnboardingOptionsComponent,
  SatelliteComponent,
  SatelliteDetailComponent,
  MainProductsComponent,
  MainExchangeComponent,
  DashboardHomeComponent,
  GuestHomeComponent,
  CommunityComponent,
  ListItemComponent,
  DemoSignupComponent,
  VideoListItemComponent,
  LessonDetailComponent,
  CourseDetailComponent,
  VideoGridItemComponent,
  NotificationPreferencesComponent,
  CommunitySearchComponent,
  CommunityPostDetailComponent,
  ProductPurchaseUpgradeComponent,
  StripePaymentComponent,
  MissedPaymentNotice,
  CheckoutProductDetailsComponent,
  PaginatorComponent,
  UserOrderListComponent,
  ConnectAuthComponent,
  AccountOrdersComponent,
  AddressesComponent,
  GiftCardsComponent,
  ...ACCOUNT_COMPONENTS,
  ...COMMUNITY_COMPONENTS,
  ...ADMIN_COMPONENTS,
  ...ADMINPORTAL_COMPONENTS,
  ...MODALS_COMPONENTS,
  ...FENDERUI_COMPONENTS,
];

export * from "./user-hover-card/user-hover-card.component";
export * from "./order-detail/order-detail.component";
export * from "./video-player/video-player.component";
export * from "./download-tile/download-tile.component";
export * from "./product-tile/product-tile.component";
export * from "./fui-learn/fui-learn.component";
export * from "./exchange-list-item/exchange-list-item.component";
export * from "./stars/stars.component";
export * from "./switch/switch.component";
export * from "./video-rail/video-rail.component";
export * from "./filterable-video-group/filterable-video-group.component";
export * from "./svg/svg.component";
export * from "./autocomplete-dropdown/autocomplete-dropdown.component";
export * from "./new-product-added/new-product-added.component";
export * from "./installer-buttons/installer-buttons.component";
export * from "./bundled-downloads/bundled-downloads.component";
export * from "./product-downloads/product-downloads.component";
export * from "./exchange-list/exchange-list.component";
export * from "./exchange-detail/exchange-detail.component";
export * from "./browse-exchange/browse-exchange.component";
export * from "./creator/creator.component";
export * from "./profile/profile.component";
export * from "./login/login.component";
export * from "./knowledgebase/knowledgebase.component";
export * from "./ticket-detail/ticket-detail.component";
export * from "./featured-creators/featured-creators.component";
export * from "./product-filter/product-filter.component";
export * from "./cloud-nav/cloud-nav.component";
export * from "./admin-nav/admin-nav.component";
export * from "./product-detail/product-detail.component";
export * from "./products-list/products-list.component";
export * from "./account/account.component";
export * from "./account/sections/general/general.component";
export * from "./account/sections/skills/skills.component";
export * from "./account/sections/showcases/showcases.component";
export * from "./account/sections/plan-stripe/plan-stripe.component";
export * from "./account/sections/play-plan/play-plan.component";
export * from "./account/sections/plan-generic/plan-generic.component";
export * from "./account/sections/notifications/notifications.component";
export * from "./account/sections/collaboration/collaboration.component";
export * from "./account/sections/connections/connections.component";
export * from "./account/sections/file-management/file-management.component";
export * from "./account/sections/addresses/addresses.component";
export * from "./account/sections/gift-cards/gift-cards.component";
export * from "./account/sections/orders/orders.component";
export * from "./support/support.component";
export * from "./cloud-nav-overlay/cloud-nav-overlay.component";
export * from "./workspace-detail/workspace-detail.component";
export * from "./file-detail/file-detail.component";
export * from "./collaboration-invite-notice/collaboration-invite-notice.component";
export * from "./fui-events/fui-events.component";
export * from "./fui-event-detail/fui-event-detail.component";
export * from "./fui-upcoming-live-event/fui-upcoming-live-event.component";
export * from "./orders/orders.component";
export * from "./segmented-bar/segmented-bar.component";
export * from "./image-viewer/image-viewer.component";
export * from "./message-input/message-input.component";
export * from "./mention-picker/mention-picker.component";
export * from "./mention-picker/mention-overlay.controller";
export * from "./chat/chat.component";
export * from "./video-notes/video-notes.component";
export * from "./notification/notification.component";
export * from "./comment/comment.component";
export * from "./reaction-control/reaction-control.component";
export * from "./workspace-files/workspace-files.component";
export * from "./audio-player/audio-player.component";
export * from "./inline-loader/inline-loader.component";
export * from "./subscription-time-meter/subscription-time-meter.component";
export * from "./waveform-comments/waveform-comments.component";
export * from "./waveform-container/waveform-container.component";
export * from "./onboarding-options/onboarding-options.component";
export * from "./satellite/satellite.component";
export * from "./satellite-detail/satellite-detail.component";
export * from "./notifications-overlay/notifications-overlay.component";
export * from "./notification-item/notification-item.component";
export * from "./main-products/main-products.component";
export * from "./main-exchange/main-exchange.component";
export * from "./dashboard-home/dashboard-home.component";
export * from "./guest-home/guest-home.component";
export * from "./community/community.component";
export * from "./list-item/list-item.component";
export * from "./demo-signup/demo-signup.component";
export * from "./video-list-item/video-list-item.component";
export * from "./video-grid-item/video-grid-item.component";
export * from "./learn-list-item/learn-list-item.component";
export * from "./learn-content-picker/learn-content-picker.component";
export * from "./course-detail/course-detail.component";
export * from "./lesson-detail/lesson-detail.component";
export * from "./account";
export * from "./community";
export * from "./admin";
export * from "./admin-portal";
export * from "./modals";
export * from "./notification-preferences/notification-preferences.component";
export * from "./community-search/community-search.component";
export * from "./community-post-detail/community-post-detail.component";
export * from "./product-purchase-upgrade/product-purchase-upgrade.component";
export * from "./stripe-payment/stripe-payment.component";
export * from "./checkout-product-details/checkout-product-details.component";
export * from "./missed-payment-notice/missed-payment-notice.component";
export * from "./paginator/paginator.component";
export * from "./skeleton-loader/skeleton-loader.component";
export * from "./user-order-list/user-order-list.component";
export * from "./connect-auth/connect-auth.component";
export * from "./s1-status-header/s1-status-header.component";
export * from "./fui-workspaces-list/fui-workspaces-list.component";
export * from "./fui-quill-editor/fui-quill-editor.component";
// Fender-UI primitives (layout-header, sidebar-filter, content-filter, heading, etc.).
// Historically only the module registration array (`FENDERUI_COMPONENTS`) was imported
// from this barrel — the class names weren't publicly reachable via `@mypxplat/xplat/web/features`.
// Re-exported (2026-09-01) so app-level pages can inject the component types (e.g. via ViewChild)
// or import them by name; matches the shape of every other components/* subdirectory in this barrel.
export * from "./community-feed/community-feed.component";
export * from "./community-feed/community-feed.util";
export * from "./fender-ui";
